import { shopSchema } from "@/lib/schemas/shop";
import { api } from "@/lib/server";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

export function getShopFromLocalStorage() {
  const item = localStorage.getItem("kiosk_shop");
  if (!item) {
    return null;
  }

  try {
    return shopSchema.parse(JSON.parse(item));
  } catch (err) {
    return null;
  }
}

export function shopQuery(inputKey: string) {
  const kioskKey = inputKey;

  return queryOptions({
    queryKey: ["shop", kioskKey],
    initialData: () => {
      const cachedShop = getShopFromLocalStorage();
      return cachedShop?.kioskKey === kioskKey ? cachedShop : undefined;
    },
    refetchOnMount: "always",
    queryFn: async () => {
      const response = await api.auth.kiosk(kioskKey).catch((err) => {
        localStorage.removeItem("kiosk_shop");
        throw err;
      });

      localStorage.setItem("kiosk_shop", JSON.stringify({ ...response }));
      return response;
    },
  });
}

export function useShop() {
  const search = useSearch({ from: "__root__" });
  return useSuspenseQuery(shopQuery(search.kioskKey));
}
